import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { VideoProps } from './types'

export const useVideos = (videoList: VideoProps[]) => {
  const history = useHistory()
  const filteredVideoList = videoList.slice(0, 4)
  const matches = useMediaQuery('(max-width:1250px)')
  const [selectedVideo, setSelectedVideo] = useState<VideoProps>(videoList[0])

  const videoController = (action: 'next' | 'prev') => {
    const videoPosition = filteredVideoList.indexOf(selectedVideo)
    switch (action) {
      case 'next':
        setSelectedVideo(filteredVideoList[videoPosition + 1])
        break
      case 'prev':
        setSelectedVideo(filteredVideoList[videoPosition - 1])
        break
    }
  }

  return {
    selectedVideo,
    setSelectedVideo,
    history,
    matches,
    filteredVideoList,
    videoController,
  }
}
